export default "__VITE_ASSET__WMgMM1qV__"